@if (isSubheading() || hasTopDivider()) {
  <rt-divider />
}

<div class="content" (click)="$event.stopPropagation()">
  @if (!fullWidthTitle()) {
    <div class="prefix-wrapper header-item">
      <div class="align-wrapper">
        <ng-content select="[prefix]" />
      </div>
    </div>
  }

  <div class="content-wrapper header-item">
    <ng-content select="rt-segmented-control" />
    <rt-truncate>
      <ng-content />
    </rt-truncate>
  </div>

  @if (!fullWidthTitle()) {
    <div class="suffix-wrapper header-item">
      <div class="align-wrapper">
        <ng-content select="[suffix]" />
      </div>
    </div>
  }
</div>

<rt-divider />
